import { React, useState } from 'react';
import LandingHeader from './header';
import "./landingpage.css"
import mainBG from "../assets/images/svgIcons/landingpage/landingBg.jpg"
import burger from "../assets/images/burger.png"
import Pizza from "../assets/images/pizza12.png"
import nuggets from "../assets/images/nuggets.png"
import sandwich from "../assets/images/sandwich.png"
const Service = () => {

    return (
        <div className='p-5'>
            <div className='center  hadding'>We Provide Best Services</div>
            <div className='container pt-4'>
                <div className='grid'>
                    <div class="card " >
                        <div class="card-body">
                            <h5 class="carheader">Pizza</h5>
                            <div className='cardsubhead'>is a dish of italian origin
                                consisting of a usually round,
                                flat base of leavened wheat-based
                                dough topped with tomatoes, cheese</div>
                            <div className='center center'><img src={Pizza} className='img-fluid' /></div>
                        </div>
                    </div>
                    <div class="card" >
                        <div class="card-body">
                            <h5 class="carheader">Burger</h5>
                            <div className='cardsubhead'>High quality beef medium to well with cheese
                                and bacon on a multigrain bun.
                                "Juicy, big, loaded with toppings
                                of my choice."</div>
                            <div className='center'><img src={burger} className='img-fluid' /></div>
                        </div>
                    </div>
                    <div class="card" >
                        <div class="card-body">
                            <h5 class="carheader">Nuggets</h5>
                            <div className='cardsubhead'>A chicken nugget is a food product
                                consisting of a small piece of
                                deboned chicken meat that is
                                breaded or battered</div>
                            <div className='center'><img src={nuggets} className='img-fluid' /></div>
                        </div>
                    </div>
                    <div class="card" >
                        <div class="card-body">
                            <h5 class="carheader">Sandwich</h5>
                            <div className='cardsubhead'>A chicken nugget is a food product
                                consisting of a small piece of
                                deboned chicken meat that is
                                breaded or battered</div>
                            <div className='center'>
                                <img src={sandwich} className='img-fluid' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service;
